import { render, staticRenderFns } from "./FolderTreeItem.vue?vue&type=template&id=9e3f9f8e"
import script from "./FolderTreeItem.js?vue&type=script&lang=js&external"
export * from "./FolderTreeItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports